const SEMINAR_END_POINT = {
  GET_SEMINAR: "/kiban/api/seminar-entry/seminar/get",
  GET_ENTRY_USER: "/kiban/api/seminar-entry/entry-user/get",
  ENTRY: "/kiban/api/seminar-entry/entry",
} as const

export default SEMINAR_END_POINT
